<section class="hero-section">
  <div class="container mx-lg-5">
    <div class="hero-content p-lg-5 p-3 rounded">
      <div class="display-5 fw-bold mb-4">Our Project Approach & Communication Strategy</div>
      <p class="lead mb-4">Accelerate time-to-value and maintain full control-delivered through Maganti IT's
        agile, transparent approach.</p>
      <div class="btn-wrapper">
        <!-- <button class="btn btn-transparent btn-lg">Learn More</button> -->
        <a href="contact" class="global_button   text-left col text-white white_button" aria-label="View Contact Page">
          <div class="dub-arrow"><img src="../../../assets/images/button/arrowWhite.png" alt="arrow_img" /></div>
          TALK TO OUR EXPERT
        </a>
      </div>
    </div>
  </div>
</section>
<!-- What We Do Section -->
<section class=" py-5 bg-light">
  <div class="container ">
    <h2 class="text-center section-title ms-0">How we work</h2>
    <div class="text-center h2 mb-4">A Proven Framework for Reliable Results</div>
    <div class="row g-0 align-items-stretch">
      <div class="col-lg-6 d-flex px-3 px-lg-0">
        <img src="../../../assets/images/ProjectApproach-images/Neutral Process Diagram Graph (1).png" alt="Tall Image"
          class="w-100 h-100 object-fit-contain"
          style="object-fit: cover;box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;">
      </div>
      <div class="col-lg-6 d-flex flex-column  ps-3 ps-lg-4 pe-3 pe-lg-0 px-3 justify-content-center">
        <p class=" mt-2 mb-4 hiringSec">Complex projects don't fail because of technology.
          They fail because of unclear goals, poor communication, and solutions that don't scale. At Maganti IT, we've built a delivery framework that removes the guesswork,
          eliminates bottlenecks, and
          aligns every milestone to measurable business value.</p>
        <!-- <p class="mt-2 mb-4 hiringSec"></p> -->
        <p class=" mt-2 mb-2 hiringSec"> Our approach is not just about writing code or
          delivering assets. It's about de-risking your investment and delivering outcomes that lost.</p>
      </div>
    </div>
  </div>
</section>
<section class="consulting-section py-3 py-lg-5">
  <div class="container">
    <div class="row align-items-stretch g-0 flex-lg-row flex-column-reverse ">
      <div class="col-lg-8 d-flex flex-column justify-content-center  ps-3 ps-lg-2 pe-3 pe-lg-5 ">
        <div class="h4 mb-4 fw-bold pt-3 pt-lg-0  lh">Discovery That Drives Business Outcomes</div>
        <p class="mb-4 hiringSec">We begin with an in-depth discovery process designed to surface not just technical
          requirements,
          but business pain point and success drivers.</p>
        <p class="mb-2 hiringSec">Our process includes :</p>

        <ul class="list-unstyled">
          <li class="mb-3">
            <i class="bi bi-check-circle-fill text-primary me-2"></i>
            Executive stakeholder workshops.
          </li>
          <li class="mb-3">
            <i class="bi bi-check-circle-fill text-primary me-2"></i>
            Process mapping and technology assessments.
          </li>
          <li class="mb-3">
            <i class="bi bi-check-circle-fill text-primary me-2"></i>
            Goal alignment and success metrics (KPIs, ROI, OKRs).
          </li>
          <li class="mb-3">
            <i class="bi bi-check-circle-fill text-primary me-2"></i>
            Risk identification and mitigation planning.
          </li>
        </ul>
        <p class="mb-4 "><b>Outcome :</b> A shared roadmap backed by business logic-not assumptions.</p>
      </div>
      <div class="col-lg-4  d-flex px-3 px-lg-0">
        <img src="../../../assets/images/ProjectApproach-images/16519 2.jpg" alt="Consulting Services"
          class="w-100 h-100 object-fit-cover "
          style="object-fit: cover;box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;">
      </div>
    </div>
  </div>
</section>
<section class="solutions-section py-3 py-lg-5 bg-light">
  <div class="container">
    <div class="row g-0 align-items-strech">

      <div class="col-lg-4  d-flex  ps-3 ps-lg-1 pe-3 pe-lg-3">
        <img src="../../../assets/images/ProjectApproach-images/2150038840 2.jpg" alt="Tall Image"
          class="w-100 h-100 object-fit-cover rounded-1"
          style="object-fit: cover;box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;">
      </div>
      <div class="col-lg-8 d-flex flex-column justify-content-center ps-3 ps-lg-5 pe-3 pe-lg-0">
        <div class="mb-4 h4 fw-bold pt-3 pt-lg-0 lh">Solutions Design: Built for Scale, Not for Shelf Life</div>
        <p class="mb-3 hiringSec ">Expand your workforce without borders. With our Embedded Global Teams, you gain
          access
          to top-tier talent worldwide, seamlessly integrated into your operations from day one.</p>
        <p class="mb-2  hiringSec">Our process includes :</p>
        <ul class="list-unstyled">
          <li class="mb-3">
            <i class="bi bi-check-circle-fill text-primary me-2"></i>
            Architecture design and cloud strategy.
          </li>
          <li class="mb-3">
            <i class="bi bi-check-circle-fill text-primary me-2"></i>
            Platform and tool selection.
          </li>
          <li class="mb-3">
            <i class="bi bi-check-circle-fill text-primary me-2"></i>
            Delivery planning with resource commitments.
          </li>
          <li class="mb-3">
            <i class="bi bi-check-circle-fill text-primary me-2"></i>
            Sprint plans and timelines that work for business.
          </li>
        </ul>
        <p class="mb-4 hiringSec"><b>Outcome :</b> A scalable, reliable blueprint you can execute with confidence.</p>

      </div>
    </div>
  </div>
</section>

<section class="consulting-section py-3 py-lg-5 ">
  <div class="container">
    <div class="row align-items-stretch g-0 flex-lg-row flex-column-reverse ">
      <div class="col-lg-8 d-flex flex-column justify-content-center ps-3 ps-lg-2 pe-3 pe-lg-5">
        <div class="h4 mb-4 fw-bold pt-3 pt-lg-0 lh">Iterative Development with you in the Loop</div>
        <p class="mb-4 hiringSec">No black boxes. No jargon walls. Every two weeks-or sooner-you see progress, provide
          feedback, and influence what comes next.</p>
        <p class="mb-2 hiringSec">You receive :</p>

        <ul class="list-unstyled">
          <li class="mb-3">
            <i class="bi bi-check-circle-fill text-primary me-2"></i>
            Sprint demos with working features.
          </li>
          <li class="mb-3">
            <i class="bi bi-check-circle-fill text-primary me-2"></i>
            Transparent backlog grooming and planning.
          </li>
          <li class="mb-3">
            <i class="bi bi-check-circle-fill text-primary me-2"></i>
            Continuous integration and test automation
          </li>
          <li class="mb-3">
            <i class="bi bi-check-circle-fill text-primary me-2"></i>
            Secure code reviews and quality gates.
          </li>
        </ul>
        <p class="mb-4 hiringSec"><b>Outcome :</b> Faster progress. No surprises. Solutions that evolve with your
          feedback.</p>
      </div>
      <div class="col-lg-4  d-flex px-3 px-lg-0">

        <img src="../../../assets/images/ProjectApproach-images/person-working-html-computer 2.jpg"
          alt="Consulting Services" class="w-100 h-100 object-fit-cover rounded-1"
          style="object-fit: cover;box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;">
      </div>
    </div>
  </div>
</section>
<!-- Consulting Section -->
<!-- Leadership Hiring Section -->
<section class="solutions-section bg-light py-3 py-lg-5">
  <div class="container">
    <div class="row align-items-stretch g-0 ">
      <div class="col-lg-4 d-flex  ps-3 ps-lg-1 pe-3 pe-lg-3">
        <img src="../../../assets/images/ProjectApproach-images/modern-equipped-computer-lab 2.jpg"
          alt="Leadership Hiring" class="w-100 h-100 object-fit-cover rounded-1"
          style="object-fit: cover;box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;">
      </div>
      <div class="col-lg-8  d-flex flex-column justify-content-center ps-3 ps-lg-5 pe-3 pe-lg-0">
        <div class="h4 mb-4 mt 3 fw-bold pt-3 pt-lg-0 lh">Quality Assurance: Tested, Hardened, and Ready for the Real
          World.</div>
        <p class="mb-4 hiringSec">We don't just test for bugs. We stress-test for business readiness, security
          resilence, and long-term stability.</p> <p class="mb-2 hiringSec"> Our QA protocols include:</p>
        <ul class="list-unstyled">
          <li class="mb-3">
            <i class="bi bi-check-circle-fill text-primary me-2"></i>
            Functional, regression, and UAT testing.
          </li>
          <li class="mb-3">
            <i class="bi bi-check-circle-fill text-primary me-2"></i>
            Security scanning (static/dynamic).
          </li>
          <li class="mb-3">
            <i class="bi bi-check-circle-fill text-primary me-2"></i>
            Load, stress, and cross-browser tests.
          </li>
          <li class="mb-3">
            <i class="bi bi-check-circle-fill text-primary me-2"></i>
            Rollback and deployment safety measures.
          </li>
        </ul>
        <p class="mb-4 hiringSec"><b>Outcome : </b>Software you can stake your reputation on.</p>
      </div>
    </div>
  </div>
</section>
<section class="consulting-section py-3 py-lg-5">
  <div class="container">
    <div class="row align-items-stretch g-0 flex-lg-row flex-column-reverse ">
      <div class="col-lg-8 d-flex flex-column justify-content-center ps-3 ps-lg-2 pe-3 pe-lg-5">
        <div class="h4 mb-4 fw-bold pt-3 pt-lg-0 lh">Post-Launch Partnership: Support That Sticks Around</div>
        <p class="mb-4 hiringSec ">Many vendors cut ties at launch. We stay invested, ensuring your solution continues
          to deliver results and adapt to change. Our post-launch support includes:</p>

        <ul class="list-unstyled">
          <li class="mb-3">
            <i class="bi bi-check-circle-fill text-primary me-2"></i>
            30 day hypercare (optional).
          </li>
          <li class="mb-3">
            <i class="bi bi-check-circle-fill text-primary me-2"></i>
            SLA-based support and maintenance.
          </li>
          <li class="mb-3">
            <i class="bi bi-check-circle-fill text-primary me-2"></i>
            Performance monitoring and enhancement.
          </li>
          <li class="mb-3">
            <i class="bi bi-check-circle-fill text-primary me-2"></i>
            Training sessions and handover documentation.
          </li>
        </ul>
        <p class="mb-4 hiringSec"><b>Outcome :</b> Confidence. Continuity. Continuous improvement.</p>
      </div>
      <div class="col-lg-4  d-flex px-3 px-lg-0">
        <img src="../../../assets/images/ProjectApproach-images/AdobeStock_579137477 1.jpeg" alt="Consulting Services"
          class="w-100 h-100 object-fit-cover rounded-1"
          style="object-fit: cover;box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;">
      </div>
    </div>
  </div>
</section>
<section class="py-5 px-4 px-lg-5 " id="industrieServe">
  <div class="container-fluid industryContainer px-0">
    <h2 class="text-center  section-title ms-0 text-white">Communication Strategy</h2>
    <div class="text-center text-white h2 mb-4">Communication isn't a courtesy. It's a strategy</div>
    <p class="mb-4 text-center text-white hiringSec">Our process ensures you always know what's happening, why it's
      happening, and what's coming next.</p>
    <div class="row g-0 ">
      <div class="col-md-6 col-lg-3 p-2">
        <div class="feature-card">
          <div class="card-header text-center p-3 ">
            <img src="../../../assets/images/ProjectApproach-images/image (29).png" alt="icon" class="mb-2"
              style="width: 80px;" />
            <div class="text-dark fw-bold mt-3  fs-6 fs-sm-5 fs-md-4 fs-lg-3 fs-xl-2 ">
              How we keep in the loop</div>
          </div>
          <div class="image-fade-container">
            <div class="image-wrapper">
              <img src="../../../assets/images/ProjectApproach-images/Project Tracking (8).png" alt="Creative Teams"
                class="hover-image cutsom-img-radius ">
            </div>
            <div class="overlay-content ">
              <ul>
                <li><b>Weekly Status Calls :</b> progress, blockers, priorities. </li>
                <li><b>Sprint Reviews :</b> Demo features, gather feedback. </li>
                <li><b>Executive Check-ins :</b> Monthly strategic review. </li>
                <li><b>Shared Dashboards (Jira, DevOps) :</b> Real-time progress. </li>
                <li><b>Documentation Access :</b> Ongoing transparency. </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-lg-3 p-2">
        <div class="feature-card">
          <div class="card-header text-center p-2 ">
            <img src="../../../assets/images/ProjectApproach-images/image (32).png" alt="icon" class="mb-2"
              style="width: 55px;" />
            <div class="text-dark fw-bold mt-2 fs-6 fs-sm-5 fs-md-4 fs-lg-3 fs-xl-2">
              Dedicated Delivery Team</div>
          </div>
          <div class="image-fade-container " style="background-color: #473624;">
            <div class="image-wrapper ">
              <img src="../../../assets/images/ProjectApproach-images/image (34).png" alt="Creative Teams"
                style="border-radius: 0%;" class="hover-image object-fit-cover ">
            </div>
            <div class="overlay-content">
              <ul>
                <li><b>Project Manager - </b>Your single point of contact. </li>
                <li><b>Solution Architect - </b>Technical visionary & risk mitigator. </li>
                <li><b>Lead Developers - </b>Skilled, certified, & agile-ready. </li>
                <li><b>QA Specialists - </b>Quality guardians with automation-first mindsets. </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-lg-3 p-2">
        <div class="feature-card">
          <div class="card-header text-center p-3">
            <img src="../../../assets/images/ProjectApproach-images/image (30).png" alt="icon" class="mb-2"
              style="width: 55px;" />
            <div class="text-dark fw-bold mt-2 fs-6 fs-sm-5 fs-md-4 fs-lg-3 fs-xl-2">
              <!-- what sets our communication apart -->
              Communication That Connects
            </div>
          </div>
          <div class="image-fade-container ">
            <div class="image-wrapper ">
              <img src="../../../assets/images/ProjectApproach-images/Generated image (1).png" alt="Creative Teams"
                class="hover-image bg-white" style=" object-fit: scale-down;">
            </div>
            <div class="overlay-content">
              <ul>
                <li>You always know what's next.</li>
                <li>We raise flags early. No spin. Just facts.</li>
                <li>We document decisions, not just tasks.</li>
                <li>You're not chasing updates - we're already there.</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-lg-3 p-2">
        <div class="feature-card">
          <div class="card-header text-center p-3">
            <img src="../../../assets/images/ProjectApproach-images/image (31).png" alt="icon" class="mb-2"
              style="width: 55px;" />
            <div class="text-dark fw-bold mt-2 fs-6 fs-sm-5 fs-md-4 fs-lg-3 fs-xl-2">
              Tools That Keep Going</div>
          </div>
          <div class="image-fade-container bg-white">
            <div class="image-wrapper ">
              <img src="../../../assets/images/ProjectApproach-images/image (11).png" alt="Creative Teams"
                class="hover-image">
            </div>
            <div class="overlay-content">
              <ul>
                <li> <b>Project Tracking : </b>Jira, Azure DevOps, Trello.
                </li>
                <li><b>Collaboration : </b>Confluence, Notion, SharePoint, Miro.</li>
                <li><b>Meetings : </b>Teams, Zoom, Webex.</li>
                <li><b>DevOps : </b>GitHub, Bitbucket, Jenkins.</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="solutions-section py-5 bg-white">
  <div class="container">
    <div class="row align-items-stretch g-0" style="min-height: 100%;">
      <div class="col-lg-4 d-flex px-3 px-lg-0">
        <img src="../../../assets/images/ProjectApproach-images/AdobeStock_1139284155 1.jpeg" alt="Creative Teams"
          class="w-100 h-100 object-fit-cover rounded-1"
          style="object-fit:cover;box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;">
      </div>
      <div class="col-lg-8 d-flex flex-column justify-content-center px-3 px-lg-5 ">
        <div class="h2 mb-4 hiringblocks pt-3 pt-lg-0">Ready to Work with a Team That's As Invested As You Are? </div>
        <p class="mb-4 hiringSec"> Let's talk about your project - where it is, where it needs to be, and how we can
          help get you there. </p>
        <ul class="list-unstyled">
          <li class="mb-3">
            <i class="bi bi-check-circle-fill text-primary me-2"></i>
            Schedule a Strategy Call.
          </li>
          <li class="mb-3">
            <i class="bi bi-check-circle-fill text-primary me-2"></i>
            Talk to a Delivery Expert.
          </li>
        </ul>
      </div>
    </div>
  </div>
</section>
<section class="py-5 bg-light">
  <div class="container">
    <div class="text-center h2 mb-5 fw-bold">Frequently Asked Questions</div>
    <div class="accordion" id="faqAccordion">
      <div class="row justify-content-center g-0">
        <div class="col-12 col-lg-9">
          <!-- Item 1 -->
          <div class="accordion-item mb-3 shadow-sm border-0 rounded">
            <h2 class="accordion-header" id="headingOne">
              <button class="accordion-button collapsed fw-semibold" type="button" data-bs-toggle="collapse"
                data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                Can you manage payroll and HR compliance for contractors?
              </button>
            </h2>
            <div id="collapseOne" class="accordion-collapse collapse" data-bs-parent="#faqAccordion">
              <div class="accordion-body">
                Yes. We handle full onboarding, timesheet management, compliance, and benefits administration under our
                Payroll & Compliance service.
              </div>
            </div>
          </div>
          <!-- Item 2 -->
          <div class="accordion-item mb-3 shadow-sm border-0 rounded">
            <h2 class="accordion-header" id="headingTwo">
              <button class="accordion-button collapsed fw-semibold" type="button" data-bs-toggle="collapse"
                data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                Are your consultants eligible to work on government contracts?
              </button>
            </h2>
            <div id="collapseTwo" class="accordion-collapse collapse" data-bs-parent="#faqAccordion">
              <div class="accordion-body">
                Yes, our talent pool includes professionals with extensive public sector experience. In fact, a majority
                of our team members possess active security clearances, enabling them to seamlessly support government
                and sensitive projects requiring elevated trust and compliance.
              </div>
            </div>
          </div>
          <!-- Item 3 -->
          <div class="accordion-item mb-3 shadow-sm border-0 rounded">
            <h2 class="accordion-header" id="headingThree">
              <button class="accordion-button collapsed fw-semibold" type="button" data-bs-toggle="collapse"
                data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                Do you support volume hiring or bulk staffing needs?
              </button>
            </h2>
            <div id="collapseThree" class="accordion-collapse collapse" data-bs-parent="#faqAccordion">
              <div class="accordion-body">
                Yes. We have experience with large-scale rollouts and enterprise projects that require rapid hiring
                across multiple roles.
              </div>
            </div>
          </div>

          <!-- Item 4 -->
          <div class="accordion-item mb-3 shadow-sm border-0 rounded">
            <h2 class="accordion-header" id="headingFour">
              <button class="accordion-button collapsed fw-semibold" type="button" data-bs-toggle="collapse"
                data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                Do you provide staffing for short-term projects?
              </button>
            </h2>
            <div id="collapseFour" class="accordion-collapse collapse" data-bs-parent="#faqAccordion">
              <div class="accordion-body">
                Yes, we support short-term, high-impact project staffing, even for engagements lasting just a few weeks.
              </div>
            </div>
          </div>

          <!-- Item 5 -->
          <div class="accordion-item mb-3 shadow-sm border-0 rounded">
            <h2 class="accordion-header" id="headingFive">
              <button class="accordion-button collapsed fw-semibold" type="button" data-bs-toggle="collapse"
                data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                What locations do you support for on-site staffing?
              </button>
            </h2>
            <div id="collapseFive" class="accordion-collapse collapse" data-bs-parent="#faqAccordion">
              <div class="accordion-body">
                We provide on-site support across the U.S. and can source regionally or nationally as needed.
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</section>